import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import { successPartnersPics } from "constants/constants";
import { useTranslation } from "react-i18next";

const SuccessPartners = () => {
  const { t, i18n } = useTranslation();
  return (
    <section className="mt-[150px] w-full ">
      <div className="mainContainer w-full h-full">
        {/* main header and description  ******************/}
        <div
          className={`my-[40px] flex flex-col items-center justify-center text-second_color text-[32px] font-${
            i18n.language === "en" ? "Poppins" : "Almarai"
          } font-[600]`}
        >
          <p>{t("Success partners")}</p>

          <p
            className={`max-w-[914px] px-[20px] lg:px-0 text-center font-${
              i18n.language === "en" ? "Poppins" : "Almarai"
            } font-[400] text-[14px] text-[#444444]`}
          >
            {t(
              "Al-Ittihad Charitable Foundation seeks to strengthen relations with local institutions in the country, and its outcome was an elite group of partnerships that were credited, after God Almighty, with participating in supporting the Foundation in achieving its goals in a way that serves the interests of those in need, which is represented in providing the finest humanitarian and charitable services."
            )}
          </p>
        </div>

        {/* Success partners card section  ****************/}
        <div className="px-[20px] lg:px-0 flex flex-wrap items-center justify-center gap-[20px] overflow-hidden ">
          <Splide
            options={{
              direction: `${
                localStorage.getItem("dir") === "rtl" ? "rtl" : "ltr"
              }`,
              grag: "free",
              arrows: false,
              pagination: false,
              width: "90%",
              autoplay: true,
              pauseOnHover: false,
              pauseOnFocus: false,
              rewind: true,
              perMove: 1,
              speed: 2000,
              interval: 3000,
              breakpoints: {
                8560: { perPage: 7, gap: 0 },
                4560: { perPage: 7, gap: 0 },
                2560: { perPage: 7, gap: 0 },
                1920: { perPage: 7, gap: 0 },
                1400: { perPage: 5, gap: 0 },
                1100: { perPage: 5, gap: 0 },
                800: { perPage: 3, gap: 0 },
                425: { perPage: 2, gap: 0 },
              },
            }}
            className="flex items-center justify-center"
          >
            {successPartnersPics?.map((pic: any) => {
              return (
                <SplideSlide key={pic?.id}>
                  <div
                    data-aos="zoom-in"
                    data-aos-duration="1000"
                    className="w-[120px] lg:w-[140px] h-[120px] shadow-shadow_sec"
                  >
                    <img src={`images/client${pic?.id}.png`} alt="" />
                  </div>
                </SplideSlide>
              );
            })}
          </Splide>
        </div>
      </div>
    </section>
  );
};

export default SuccessPartners;
